import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { showToast } from "../toastService";
import { AUTH_BASE_URL, VERSION, apiClientHeaders } from "../utils/config";
import "../styles/Navbar.css";

export default function Navbar({ fixed = false }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  // Close menu when clicking outside
  useEffect(() => {
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [open]);

  const handleLogout = async () => {
    const accessToken = localStorage.getItem("accessToken");

    if (accessToken) {
      try {
        await fetch(`${AUTH_BASE_URL}/${VERSION}/user/logout`, {
          method: "GET",
          headers: apiClientHeaders({
            Authorization: `Bearer ${accessToken}`,
          }),
        });
      } catch (error) {
        console.error("Logout API failed:", error);
      }
    }

    // Ensure tokens are cleared even if API call fails
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("isAuthenticated");

    showToast("Logged out successfully!", "error");

    navigate("/");
  };

  return (
    <>
      {/* Overlay */}
      {open && <div className="menu-overlay" />}

      <div className={`navbar ${fixed ? "navbar-fixed" : ""}`} ref={menuRef}>
        {/* Menu Icon */}
        <button
          className="menu-btn"
          onClick={() => setOpen((prev) => !prev)}
          aria-label="Toggle Menu"
        >
          <img src="/assets/images/menubar.svg" alt="menu" />
        </button>

        {/* Dropdown Menu */}
        {open && (
          <div className="menu-dropdown">
            <a href="https://g9eduinternational.com/terms-conditions/" target="_blank" rel="noopener noreferrer">
              Terms & Condition
            </a>
            <a href="https://g9eduinternational.com/privacy-policy/" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
            <a href="https://g9eduinternational.com/shipping-policy/" target="_blank" rel="noopener noreferrer">
              Shipping Policy
            </a>
            <a href="https://g9eduinternational.com/cancellation-refunds/" target="_blank" rel="noopener noreferrer">
              Refund Policy
            </a>
            <a href="https://g9eduinternational.com/contact/" target="_blank" rel="noopener noreferrer">
              Contact Us
            </a>
            <button onClick={() => handleLogout()}>
              Log Out
            </button>
          </div>
        )}
      </div>
    </>
  );
}